/**
 * @generated SignedSource<<66facbb9f7049435259a40e71dc90ac8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type getAccountTreeQuery$variables = {
  id: number;
};
export type getAccountTreeQuery$data = {
  readonly sys_organization_account_trees: ReadonlyArray<{
    readonly account_tree_name: string;
    readonly organization: {
      readonly organization_label: string;
    } | null;
    readonly organization_account_tree_id: number;
    readonly updated_at_datetime: string;
  }>;
};
export type getAccountTreeQuery = {
  response: getAccountTreeQuery$data;
  variables: getAccountTreeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "id"
              }
            ],
            "kind": "ObjectValue",
            "name": "organization_account_tree_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_organization_account_trees",
    "kind": "LinkedField",
    "name": "sys_organization_account_trees",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organization_account_tree_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "account_tree_name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updated_at_datetime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_organizations",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organization_label",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getAccountTreeQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getAccountTreeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f1348c9b8bff16834fa76fa91c3772a1",
    "id": null,
    "metadata": {},
    "name": "getAccountTreeQuery",
    "operationKind": "query",
    "text": "query getAccountTreeQuery(\n  $id: Int!\n) {\n  sys_organization_account_trees(where: {organization_account_tree_id: {_eq: $id}}) {\n    organization_account_tree_id\n    account_tree_name\n    updated_at_datetime\n    organization {\n      organization_label\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "362f3c923b6922cd289760589cae9321";

export default node;
